export default __webpack_public_path__ + "static/Dashboard-6@2x-0c85aa3253aa102c0f4b767b9746a6e9.svg";